import React from 'react';
import { Search } from 'lucide-react';
import { DEMAND_FILTERS, SUBSCRIPTION_TABS } from '../../utils/ipoSubscription';

export const SubscriptionControls = ({
  tab,
  onTabChange,
  tabCounts,
  demand,
  onDemandChange,
  query,
  onQueryChange,
  tabs = SUBSCRIPTION_TABS,
  searchPlaceholder = 'Quick filter company…',
}) => (
  <div className="flex flex-col xl:flex-row xl:items-center justify-between gap-3 bg-white rounded-2xl border border-slate-200/90 shadow-sm p-2.5 sm:p-3">
    <div role="group" aria-label="Issue list" className="inline-flex self-start gap-1 p-1 rounded-xl bg-slate-100 border border-slate-200/80 overflow-x-auto max-w-full">
      {tabs.map((option) => {
        const active = option.key === tab;
        return (
          <button
            key={option.key}
            type="button"
            aria-pressed={active}
            onClick={() => onTabChange(option.key)}
            className={`px-3 py-1.5 rounded-lg text-xs font-bold whitespace-nowrap transition-all ${
              active ? 'bg-white text-[#008080] shadow-sm' : 'text-slate-600 hover:text-slate-900'
            }`}
          >
            {option.label} ({tabCounts[option.key]})
          </button>
        );
      })}
    </div>

    <div className="flex flex-col sm:flex-row sm:items-center gap-2.5">
      <div role="group" aria-label="Filter by demand" className="flex flex-wrap items-center gap-1.5">
        <span className="text-[11px] font-semibold text-slate-400 mr-0.5">Filter:</span>
        {DEMAND_FILTERS.map((filter) => {
          const active = filter.key === demand;
          return (
            <button
              key={filter.key}
              type="button"
              aria-pressed={active}
              onClick={() => onDemandChange(filter.key)}
              className={`px-2.5 py-1 rounded-full text-[11px] font-bold border transition-colors ${
                active
                  ? 'bg-slate-900 border-slate-900 text-white'
                  : 'bg-white border-slate-200 text-slate-600 hover:border-slate-300'
              }`}
            >
              {filter.label}
            </button>
          );
        })}
      </div>
      <label className="relative block sm:w-56">
        <span className="sr-only">Filter by company</span>
        <Search className="w-3.5 h-3.5 text-slate-400 absolute left-3 top-1/2 -translate-y-1/2 pointer-events-none" />
        <input
          type="search"
          value={query}
          onChange={(e) => onQueryChange(e.target.value)}
          placeholder={searchPlaceholder}
          className="w-full pl-8 pr-3 py-1.5 bg-white border border-slate-200 rounded-lg text-xs text-slate-800 placeholder-slate-400 focus:outline-none focus:border-[#008080] focus:ring-1 focus:ring-[#008080]"
        />
      </label>
    </div>
  </div>
);

export default SubscriptionControls;
